import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { LanguageService } from '@shared/shared/services/language-service';
import { replaceTemplateKeys } from '@shared/utils/url.lib';
import { TRAVEL_HOTEL_DETAILS_LOCAL_STORAGE_KEY } from 'app.config';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as fromActions from '../actions/hotel-details.actions';

@Injectable()
export class HotelDetailsEffects implements OnInitEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private languageService: LanguageService,
    private router: Router
  ) {}

  public ngrxOnInitEffects(): Action {
    return new fromActions.RestoreHotelDetail();
  }

  public restoreHotelDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.RESTORE_HOTEL_DETAIL),
      map(() => {
        const hotelDetailsString = localStorage.getItem(TRAVEL_HOTEL_DETAILS_LOCAL_STORAGE_KEY);

        return new fromActions.RestoreHotelDetailSuccess(hotelDetailsString ? JSON.parse(hotelDetailsString) : null);
      })
    )
  );

  public getHotelDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.GET_HOTEL_DETAIL),
      switchMap((action: fromActions.GetHotelDetail) => {
        const url = replaceTemplateKeys(ApiEndpoint.TRAVEL_HOTEL_SEARCH_RESULT, {
          id: action.payload.toString(),
          locale: this.languageService.currentLanguage,
        });

        return this.http.get(url).pipe(
          map((data) => {
            return new fromActions.GetHotelDetailSuccess({
              ...data,
              hotel: {
                ...data,
              },
            });
          }),
          catchError((error: any) => {
            this.router.navigate(['/error/not-found']);
            return of(new fromActions.GetHotelDetailFail(error));
          })
        );
      })
    )
  );

  public saveHotelDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.GET_HOTEL_DETAIL_SUCCESS),
        tap((action: fromActions.GetHotelDetailSuccess) => {
          localStorage.setItem(TRAVEL_HOTEL_DETAILS_LOCAL_STORAGE_KEY, JSON.stringify(action.payload));
        })
      ),
    { dispatch: false }
  );

  public clearHotelDetails$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromActions.CLEAR_HOTEL_DETAILS),
        tap(() => {
          localStorage.removeItem(TRAVEL_HOTEL_DETAILS_LOCAL_STORAGE_KEY);
        })
      ),
    { dispatch: false }
  );
}
